const tags = [
  {
    title: "Java • Spring Boot",
  },
  {
    title: "React • JavaScript",
  },
  {
    title: "Oracle • SQL",
  },
  {
    title: "AWS • Docker",
  },
  {
    title: "Git • CI/CD",
  },
  {
    title: "DevOps • Linux",
  },
];

export default tags;
